import { IResult, UAParser } from 'ua-parser-js';

const parser = new UAParser();
const ua = parser.getResult();

export const userDeviceInfo = {
  deviceName: formatDeviceName(ua),
  browser: `${ua.browser.name} ${ua.browser.version}`,
  platform: ua.os.name,
  userAgent: navigator.userAgent,
  lastLoggedIn: new Date().toISOString(),
};

function formatDeviceName(ua: IResult) {
  if (ua.device.model) {
    return `${ua.device.model}${ua.os.name ? ` (${ua.os.name})` : ''}`;
  } else if (ua.os.name) {
    return `${ua.os.name}${ua.browser.name ? ` (${ua.browser.name})` : ''}`;
  }
  return 'Unknown Device';
}
